import { hasCapability, type User } from "../base";

export const assessment = {
  read: (user: User) => hasCapability(user, "assessment.read"),
  create: (user: User) => hasCapability(user, "assessment.create"),
  update: (user: User) => hasCapability(user, "assessment.update"),
};
